var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pa-0" },
    [
      _c(
        "div",
        { staticStyle: { display: "grid", gap: "24px" } },
        [
          _c(
            "div",
            { staticClass: "mt-24px" },
            [
              _vm.getMenuItemVisible("edit_najomca")
                ? _c(
                    "v-btn",
                    {
                      staticClass: "btn-secondary",
                      attrs: {
                        disabled: !_vm.getMenuItemEnabled("edit_najomca")
                      },
                      on: {
                        click: function($event) {
                          return _vm.redirectToEditNajomca(
                            _vm.pripad.newId,
                            true
                          )
                        }
                      }
                    },
                    [_vm._v("Pridať novú kontaktnú osobu")]
                  )
                : _vm._e(),
              _c(
                "v-btn",
                {
                  staticClass: "btn-secondary ml-16px",
                  attrs: {
                    disabled: _vm.pripad == null || _vm.pripad.newId == null
                  },
                  on: {
                    click: function($event) {
                      return _vm.redirectToUploadDokumentov(
                        _vm.pripad.newId,
                        "0",
                        "",
                        "sumar-zadatel"
                      )
                    }
                  }
                },
                [_vm._v(" Dokumenty ")]
              ),
              _c(
                "v-tooltip",
                {
                  attrs: { top: "", "close-delay": 0, "open-delay": 200 },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        return [
                          _vm.getMenuItemVisible("edit_najomca")
                            ? _c(
                                "v-btn",
                                _vm._g(
                                  {
                                    staticClass: "btn-secondary right btn-icon",
                                    attrs: {
                                      disabled: !_vm.getMenuItemEnabled(
                                        "edit_najomca"
                                      )
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.redirectToEditNajomca(
                                          _vm.pripad.newId
                                        )
                                      }
                                    }
                                  },
                                  on
                                ),
                                [_c("v-icon", [_vm._v("mdi-pencil-outline")])],
                                1
                              )
                            : _vm._e()
                        ]
                      }
                    }
                  ])
                },
                [_c("span", [_vm._v("Editovať")])]
              )
            ],
            1
          ),
          _vm.pravoNaAdresnuPonuku &&
          (_vm.suhlasyNajomcovia.length > 0 ||
            _vm.showSuhlasySensitiveBusiness) &&
          _vm.jeDealer
            ? _c(
                "v-card",
                { staticClass: "card" },
                [
                  _c(
                    "v-expansion-panels",
                    {
                      staticClass: "wizard-expansion-panels",
                      attrs: { flat: "" },
                      model: {
                        value: _vm.panel,
                        callback: function($$v) {
                          _vm.panel = $$v
                        },
                        expression: "panel"
                      }
                    },
                    [
                      _c(
                        "v-expansion-panel",
                        [
                          _c(
                            "v-expansion-panel-header",
                            { staticClass: "pa-0" },
                            [_c("h2", [_vm._v("Súhlasy")])]
                          ),
                          _c(
                            "v-expansion-panel-content",
                            [
                              _vm._l(_vm.suhlasyNajomcovia, function(
                                sn,
                                index
                              ) {
                                return _c(
                                  "v-form",
                                  {
                                    key: index,
                                    ref:
                                      "form_suhlasy" +
                                      sn.suhlasy[0].id_zastupcu,
                                    refInFor: true,
                                    staticClass: "mt-20px",
                                    staticStyle: {
                                      border: "1px solid #2c2e34",
                                      "max-width": "100%",
                                      "text-align": "left",
                                      "border-radius": "12px"
                                    },
                                    attrs: { autocomplete: "off" },
                                    model: {
                                      value: sn.formSuhlasyValid,
                                      callback: function($$v) {
                                        _vm.$set(sn, "formSuhlasyValid", $$v)
                                      },
                                      expression: "sn.formSuhlasyValid"
                                    }
                                  },
                                  [
                                    _c(
                                      "v-row",
                                      { attrs: { "no-gutters": "" } },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "pa-16px",
                                            attrs: { cols: "12" }
                                          },
                                          [
                                            sn.suhlasy !== undefined
                                              ? _c("h3", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        sn.suhlasy &&
                                                          sn.suhlasy.length
                                                          ? sn.suhlasy[0].meno
                                                          : ""
                                                      ) +
                                                      " "
                                                  )
                                                ])
                                              : _vm._e()
                                          ]
                                        ),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12" } },
                                          [_c("v-divider")],
                                          1
                                        ),
                                        _vm._l(sn.suhlasy, function(
                                          item,
                                          index
                                        ) {
                                          return _c(
                                            "v-col",
                                            {
                                              key: index,
                                              staticClass: "pa-16px pb-0",
                                              attrs: { cols: "12" }
                                            },
                                            [
                                              _c(
                                                "v-row",
                                                { attrs: { "no-gutters": "" } },
                                                [
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "auto" } },
                                                    [
                                                      _c("v-checkbox", {
                                                        staticClass:
                                                          "checkbox-suhlas",
                                                        class: {
                                                          dynamic_check_box: true,
                                                          required:
                                                            item.is_required,
                                                          successful: _vm.getSuhlasSuccess(
                                                            sn,
                                                            item
                                                          )
                                                        },
                                                        staticStyle: {
                                                          "white-space":
                                                            "normal",
                                                          "margin-top": "0px"
                                                        },
                                                        attrs: {
                                                          readonly: _vm.getSuhlasReadonly(
                                                            _vm.getSuhlas(
                                                              sn,
                                                              item
                                                            ),
                                                            item
                                                          ),
                                                          disabled: !item.is_enabled,
                                                          rules: item.is_required
                                                            ? _vm.requiredRule
                                                            : [],
                                                          label:
                                                            item.view_object_info_text
                                                        },
                                                        on: {
                                                          change: function(
                                                            val
                                                          ) {
                                                            return (sn.saved = false)
                                                          }
                                                        },
                                                        model: {
                                                          value:
                                                            item.control_value,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "control_value",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.control_value"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm.getSuhlas(sn, item) !=
                                                    null &&
                                                  _vm.getSuhlas(sn, item)
                                                    .idStavu > 0
                                                    ? _c(
                                                        "v-col",
                                                        {
                                                          staticClass: "pt-4px"
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "c-grayscale-100 ml-5 "
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.getSuhlas(
                                                                      sn,
                                                                      item
                                                                    ).nazov
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        }),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "pa-16px",
                                            attrs: { cols: "12" }
                                          },
                                          [
                                            sn.suhlasy.length > 0
                                              ? _c(
                                                  "v-btn",
                                                  {
                                                    staticClass: "btn-primary",
                                                    attrs: {
                                                      loading:
                                                        sn.suhlasyLoading,
                                                      disabled:
                                                        !_vm.getSuhlasyNaPodpis(
                                                          sn
                                                        ) ||
                                                        sn.suhlasyLoading ||
                                                        !sn.formSuhlasyValid
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.poslatNaPodpis(
                                                          sn
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Poslať na podpis ")]
                                                )
                                              : _vm._e(),
                                            sn.podpisErrorMessage
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "negative500 ml-5 mt-8px"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          sn.podpisErrorMessage
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            sn.suhlasy.length === 0
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "negative500 ml-5 mt-8px"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " Všetky potrebné súhlasy boli udelené "
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              }),
                              _vm.showSuhlasySensitiveBusiness
                                ? _c(
                                    "v-form",
                                    {
                                      staticClass: "mt-20px",
                                      staticStyle: {
                                        border: "1px solid #2c2e34",
                                        "max-width": "100%",
                                        "text-align": "left",
                                        "border-radius": "12px"
                                      },
                                      attrs: { autocomplete: "off" }
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        { attrs: { "no-gutters": "" } },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass:
                                                "c-grayscale-100 pa-16px pb-0",
                                              attrs: { cols: "12" }
                                            },
                                            [
                                              _vm._v(
                                                " Pochádza nejaká časť tržieb spoločnosti z podnikateľských aktivít súvisiacich so: "
                                              ),
                                              _c(
                                                "ul",
                                                { staticClass: "pt-8px" },
                                                [
                                                  _c("li", [
                                                    _vm._v("zbraňami")
                                                  ]),
                                                  _c("li", [
                                                    _vm._v(
                                                      "vojenským materiálom"
                                                    )
                                                  ]),
                                                  _c("li", [
                                                    _vm._v("hazardnými hrami")
                                                  ]),
                                                  _c("li", [
                                                    _vm._v(
                                                      " využitím jadrovej energie "
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "c-negative-600"
                                                      },
                                                      [_vm._v("*")]
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "pa-16px",
                                              attrs: { cols: "12" }
                                            },
                                            [
                                              _c(
                                                "v-radio-group",
                                                {
                                                  staticClass:
                                                    "sumar-radio-group",
                                                  attrs: {
                                                    disabled:
                                                      !_vm.suhlasySensitiveBusiness ||
                                                      !_vm
                                                        .suhlasySensitiveBusiness
                                                        .is_enabled ||
                                                        _vm.disableSuhlasySensitiveBusiness,
                                                    "hide-details": ""
                                                  },
                                                  on: {
                                                    change:
                                                      _vm.setSensitiveBusinessSelection
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.suhlasySensitiveBusinessValue,
                                                    callback: function($$v) {
                                                      _vm.suhlasySensitiveBusinessValue = $$v
                                                    },
                                                    expression:
                                                      "suhlasySensitiveBusinessValue"
                                                  }
                                                },
                                                [
                                                  _c("v-radio", {
                                                    attrs: {
                                                      label: "Áno, pochádza",
                                                      value: true
                                                    }
                                                  }),
                                                  _c("v-radio", {
                                                    attrs: {
                                                      label: "Nie, nepochádza",
                                                      value: false
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "pr-16px pl-16px",
                                              attrs: { cols: "12" }
                                            },
                                            [_c("v-divider")],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass:
                                                "c-grayscale-100 pa-16px",
                                              attrs: { cols: "12" }
                                            },
                                            [
                                              _vm._v(
                                                " Pred odoslaním na schválenie nahrajte dokument typu "
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "white100" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm
                                                        .suhlasySensitiveBusiness
                                                        .document_name ||
                                                        "Dotazník"
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" v sekcii Dokumenty. ")
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.pravoNaAdresnuPonuku &&
          (_vm.suhlasyNajomcovia[0] || _vm.showSuhlasySensitiveBusiness) &&
          (!_vm.jeDealer || _vm.debug)
            ? _c(
                "v-card",
                { staticClass: "card" },
                [
                  _c("v-col", { attrs: { cols: "12" } }, [
                    _c("h2", { staticClass: "mr-3" }, [_vm._v("Súhlasy")]),
                    _vm.formaPodnikania.pkId != 1
                      ? _c("p", { staticClass: "f16 c-grayscale-100 mb-0px" }, [
                          _vm._v(
                            "Pre odoslanie ponuky na schválenie je potrebné údeliť súhlas s verifikáciou do nebankových registrov."
                          )
                        ])
                      : _vm._e()
                  ]),
                  _c("v-divider"),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _vm.suhlasyNajomcovia[0]
                        ? _c(
                            "v-row",
                            {
                              staticStyle: { gap: "16px" },
                              attrs: { "no-gutters": "" }
                            },
                            _vm._l(_vm.suhlasyNajomcovia[0].suhlasy, function(
                              item,
                              index
                            ) {
                              return _c(
                                "v-col",
                                {
                                  key: index,
                                  attrs: { cols: "12", "no-gutters": "" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-flex",
                                      style: {
                                        cursor: _vm.getSuhlasReadonly(
                                          _vm.getSuhlas(
                                            _vm.suhlasyNajomcovia[0],
                                            item
                                          ),
                                          item
                                        )
                                          ? "default"
                                          : "pointer",
                                        "pointer-events": _vm.getSuhlasReadonly(
                                          _vm.getSuhlas(
                                            _vm.suhlasyNajomcovia[0],
                                            item
                                          ),
                                          item
                                        )
                                          ? "none"
                                          : "auto"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          $event.stopPropagation()
                                          return _vm.selectedSuhlas(
                                            0,
                                            item,
                                            item.control_value
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "checkbox-suhlas",
                                        class: {
                                          dynamic_check_box: true,
                                          required: item.is_required,
                                          successful: _vm.getSuhlasSuccess(
                                            _vm.suhlasyNajomcovia[0],
                                            item
                                          )
                                        },
                                        staticStyle: {
                                          "white-space": "normal",
                                          "margin-top": "0px",
                                          "pointer-events": "none"
                                        },
                                        attrs: {
                                          readonly: _vm.getSuhlasReadonly(
                                            _vm.getSuhlas(
                                              _vm.suhlasyNajomcovia[0],
                                              item
                                            ),
                                            item
                                          ),
                                          disabled: !item.is_enabled,
                                          rules: item.is_required
                                            ? _vm.requiredRule
                                            : [],
                                          label: item.view_object_info_text,
                                          "hide-details": ""
                                        },
                                        model: {
                                          value: item.control_value,
                                          callback: function($$v) {
                                            _vm.$set(item, "control_value", $$v)
                                          },
                                          expression: "item.control_value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm.showSuhlasySensitiveBusiness
                    ? _c(
                        "v-form",
                        {
                          staticStyle: {
                            border: "1px solid #2c2e34",
                            "max-width": "100%",
                            "text-align": "left",
                            "border-radius": "12px"
                          },
                          attrs: { autocomplete: "off" }
                        },
                        [
                          _c(
                            "v-row",
                            { attrs: { "no-gutters": "" } },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "c-grayscale-100 pa-16px pb-0",
                                  attrs: { cols: "12" }
                                },
                                [
                                  _vm._v(
                                    " Pochádza nejaká časť tržieb spoločnosti z podnikateľských aktivít súvisiacich so: "
                                  ),
                                  _c("ul", { staticClass: "pt-8px" }, [
                                    _c("li", [_vm._v("zbraňami")]),
                                    _c("li", [_vm._v("vojenským materiálom")]),
                                    _c("li", [_vm._v("hazardnými hrami")]),
                                    _c("li", [
                                      _vm._v(" využitím jadrovej energie "),
                                      _c(
                                        "span",
                                        { staticClass: "c-negative-600" },
                                        [_vm._v("*")]
                                      )
                                    ])
                                  ])
                                ]
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "pa-16px",
                                  attrs: { cols: "12" }
                                },
                                [
                                  _c(
                                    "v-radio-group",
                                    {
                                      attrs: {
                                        disabled:
                                          !_vm.suhlasySensitiveBusiness ||
                                          !_vm.suhlasySensitiveBusiness
                                            .is_enabled,
                                        "hide-details": ""
                                      },
                                      on: {
                                        change:
                                          _vm.setSensitiveBusinessSelection
                                      },
                                      model: {
                                        value:
                                          _vm.suhlasySensitiveBusinessValue,
                                        callback: function($$v) {
                                          _vm.suhlasySensitiveBusinessValue = $$v
                                        },
                                        expression:
                                          "suhlasySensitiveBusinessValue"
                                      }
                                    },
                                    [
                                      _c("v-radio", {
                                        attrs: {
                                          label: "Áno, pochádza",
                                          value: true
                                        }
                                      }),
                                      _c("v-radio", {
                                        attrs: {
                                          label: "Nie, nepochádza",
                                          value: false
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "pr-16px pl-16px",
                                  attrs: { cols: "12" }
                                },
                                [_c("v-divider")],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "c-grayscale-100 pa-16px",
                                  attrs: { cols: "12" }
                                },
                                [
                                  _vm._v(
                                    " Pred odoslaním na schválenie nahrajte dokument typu "
                                  ),
                                  _c("span", { staticClass: "white100" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.suhlasySensitiveBusiness
                                          .document_name || "Dotazník"
                                      )
                                    )
                                  ]),
                                  _vm._v(" v sekcii Dokumenty. ")
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-card",
            { staticClass: "card" },
            [
              _c("h2", { staticClass: "left mr-3" }, [
                _vm._v(_vm._s(_vm.najomca.najomca))
              ]),
              _c("p", { staticClass: "f16 c-grayscale-100 pt-4px" }, [
                _vm._v("(Nájomca)")
              ]),
              _c(
                "v-row",
                { staticClass: "mt-8 mb-20px" },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "3" } },
                    [
                      _c("v-text-field", {
                        staticClass: "dynamic-input-control sumar-info mb-10px",
                        attrs: {
                          label: "Typ nájomcu",
                          disabled: "",
                          "hide-details": "",
                          outlined: ""
                        },
                        model: {
                          value: _vm.najomca.typ_najomcu,
                          callback: function($$v) {
                            _vm.$set(_vm.najomca, "typ_najomcu", $$v)
                          },
                          expression: "najomca.typ_najomcu"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "3" } },
                    [
                      _c("v-text-field", {
                        staticClass: "dynamic-input-control sumar-info mb-10px",
                        attrs: {
                          value: _vm.najomca.obchodne_meno
                            ? _vm.najomca.obchodne_meno
                            : _vm.najomca.meno_najomca,
                          label: _vm.najomca.obchodne_meno
                            ? "Obchodné meno"
                            : "Meno",
                          disabled: "",
                          "hide-details": "",
                          outlined: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "3" } },
                    [
                      _c("v-text-field", {
                        staticClass: "dynamic-input-control sumar-info mb-10px",
                        attrs: {
                          value: _vm.najomca.ico
                            ? _vm.najomca.ico
                            : _vm.najomca.priezvisko_najomca,
                          label: _vm.najomca.ico ? "IČO" : "Priezvisko",
                          disabled: "",
                          "hide-details": "",
                          outlined: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "3" } },
                    [
                      _c("v-text-field", {
                        staticClass: "dynamic-input-control sumar-info mb-10px",
                        attrs: {
                          label: "Zdroj ponuky",
                          disabled: "",
                          "hide-details": "",
                          outlined: ""
                        },
                        model: {
                          value: _vm.najomca.zdroj_ponuky,
                          callback: function($$v) {
                            _vm.$set(_vm.najomca, "zdroj_ponuky", $$v)
                          },
                          expression: "najomca.zdroj_ponuky"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.jeDealer || _vm.najomca.id_zastupcu != -1
            ? _c(
                "v-card",
                { staticClass: " card" },
                [
                  _c("h2", { staticClass: "left mr-3" }, [
                    _vm._v(
                      _vm._s(_vm.najomca.meno + " " + _vm.najomca.priezvisko)
                    )
                  ]),
                  _c("p", { staticClass: "f16 c-grayscale-100 pt-7px" }, [
                    _vm._v("(Kontaktná osoba)")
                  ]),
                  _c(
                    "v-row",
                    { staticClass: "mt-10px", attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "3" } },
                        [
                          _c("v-text-field", {
                            staticClass: "dynamic-input-control sumar-info",
                            attrs: {
                              label: "Titul",
                              disabled: "",
                              "hide-details": "",
                              outlined: ""
                            },
                            model: {
                              value: _vm.najomca.titul,
                              callback: function($$v) {
                                _vm.$set(_vm.najomca, "titul", $$v)
                              },
                              expression: "najomca.titul"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "3" } },
                        [
                          _c("v-text-field", {
                            staticClass: "dynamic-input-control sumar-info",
                            attrs: {
                              label: "Pohlavie",
                              disabled: "",
                              "hide-details": "",
                              outlined: ""
                            },
                            model: {
                              value: _vm.najomca.pohlavie,
                              callback: function($$v) {
                                _vm.$set(_vm.najomca, "pohlavie", $$v)
                              },
                              expression: "najomca.pohlavie"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "3" } },
                        [
                          _c("v-checkbox", {
                            staticClass: "dynamic_check_box sumar-info",
                            attrs: {
                              label: "Zahraničná osoba",
                              disabled: "",
                              "hide-details": ""
                            },
                            model: {
                              value: _vm.najomca.zahranicna_osoba,
                              callback: function($$v) {
                                _vm.$set(_vm.najomca, "zahranicna_osoba", $$v)
                              },
                              expression: "najomca.zahranicna_osoba"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "mt-10px", attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "3" } },
                        [
                          _c("v-text-field", {
                            staticClass: "dynamic-input-control sumar-info",
                            attrs: {
                              label: "Meno",
                              disabled: "",
                              "hide-details": "",
                              outlined: ""
                            },
                            model: {
                              value: _vm.najomca.meno,
                              callback: function($$v) {
                                _vm.$set(_vm.najomca, "meno", $$v)
                              },
                              expression: "najomca.meno"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "3" } },
                        [
                          _c("v-text-field", {
                            staticClass: "dynamic-input-control sumar-info",
                            attrs: {
                              label: "Priezvisko",
                              disabled: "",
                              "hide-details": "",
                              outlined: ""
                            },
                            model: {
                              value: _vm.najomca.priezvisko,
                              callback: function($$v) {
                                _vm.$set(_vm.najomca, "priezvisko", $$v)
                              },
                              expression: "najomca.priezvisko"
                            }
                          })
                        ],
                        1
                      ),
                      _vm.pravoNaAdresnuPonuku
                        ? _c(
                            "v-col",
                            { attrs: { cols: "3" } },
                            [
                              _c("v-text-field", {
                                staticClass: "dynamic-input-control sumar-info",
                                attrs: {
                                  value: _vm.najomca.datum_narodenia
                                    ? _vm.najomca.datum_narodenia.formatDate()
                                    : "",
                                  label: "Dátum narodenia",
                                  disabled: "",
                                  "hide-details": "",
                                  outlined: ""
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.pravoNaAdresnuPonuku
                        ? _c(
                            "v-col",
                            { attrs: { cols: "3" } },
                            [
                              _c("v-text-field", {
                                staticClass: "dynamic-input-control sumar-info",
                                attrs: {
                                  label: _vm.najomca.zahranicna_osoba
                                    ? "Identifikačné číslo"
                                    : "Rodné číslo",
                                  disabled: "",
                                  "hide-details": "",
                                  outlined: ""
                                },
                                model: {
                                  value: _vm.najomca.rc,
                                  callback: function($$v) {
                                    _vm.$set(_vm.najomca, "rc", $$v)
                                  },
                                  expression: "najomca.rc"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.pravoNaAdresnuPonuku
                        ? _c(
                            "v-col",
                            { attrs: { cols: "3" } },
                            [
                              _c("v-text-field", {
                                staticClass: "dynamic-input-control sumar-info",
                                attrs: {
                                  label: "Štátne občianstvo",
                                  disabled: "",
                                  "hide-details": "",
                                  outlined: ""
                                },
                                model: {
                                  value: _vm.najomca.statne_obcianstvo,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.najomca,
                                      "statne_obcianstvo",
                                      $$v
                                    )
                                  },
                                  expression: "najomca.statne_obcianstvo"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm.pravoNaAdresnuPonuku
                    ? _c(
                        "v-row",
                        { staticClass: "mt-10px", attrs: { "no-gutters": "" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "3" } },
                            [
                              _c("v-text-field", {
                                staticClass: "dynamic-input-control sumar-info",
                                attrs: {
                                  label: _vm.najomca.zahranicna_osoba
                                    ? "Číslo dokladu"
                                    : "Číslo OP",
                                  disabled: "",
                                  "hide-details": "",
                                  outlined: ""
                                },
                                model: {
                                  value: _vm.najomca.cislo_dokladu,
                                  callback: function($$v) {
                                    _vm.$set(_vm.najomca, "cislo_dokladu", $$v)
                                  },
                                  expression: "najomca.cislo_dokladu"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "3" } },
                            [
                              _c("v-text-field", {
                                staticClass: "dynamic-input-control sumar-info",
                                attrs: {
                                  value: _vm.najomca.datum_vydania
                                    ? _vm.najomca.datum_vydania.formatDate()
                                    : "",
                                  label: _vm.najomca.zahranicna_osoba
                                    ? "Dátum od"
                                    : "Dátum vydania",
                                  disabled: "",
                                  "hide-details": "",
                                  outlined: ""
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "3" } },
                            [
                              _c("v-text-field", {
                                staticClass: "dynamic-input-control sumar-info",
                                attrs: {
                                  value: _vm.najomca.datum_platnosti
                                    ? _vm.najomca.datum_platnosti.formatDate()
                                    : "",
                                  label: _vm.najomca.zahranicna_osoba
                                    ? "Dátum do"
                                    : "Dátum platnosti",
                                  disabled: "",
                                  "hide-details": "",
                                  outlined: ""
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.pravoNaAdresnuPonuku
                    ? _c(
                        "v-row",
                        { staticClass: "mt-10px", attrs: { "no-gutters": "" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "3" } },
                            [
                              _c("v-text-field", {
                                staticClass: "dynamic-input-control sumar-info",
                                attrs: {
                                  label: "Ulica, číslo domu",
                                  disabled: "",
                                  "hide-details": "",
                                  outlined: ""
                                },
                                model: {
                                  value: _vm.najomca.ulica,
                                  callback: function($$v) {
                                    _vm.$set(_vm.najomca, "ulica", $$v)
                                  },
                                  expression: "najomca.ulica"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "3" } },
                            [
                              _c("v-text-field", {
                                staticClass: "dynamic-input-control sumar-info",
                                attrs: {
                                  label: "Mesto",
                                  disabled: "",
                                  "hide-details": "",
                                  outlined: ""
                                },
                                model: {
                                  value: _vm.najomca.mesto,
                                  callback: function($$v) {
                                    _vm.$set(_vm.najomca, "mesto", $$v)
                                  },
                                  expression: "najomca.mesto"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "3" } },
                            [
                              _c("v-text-field", {
                                staticClass: "dynamic-input-control sumar-info",
                                attrs: {
                                  label: "PSČ",
                                  disabled: "",
                                  "hide-details": "",
                                  outlined: ""
                                },
                                model: {
                                  value: _vm.najomca.psc,
                                  callback: function($$v) {
                                    _vm.$set(_vm.najomca, "psc", $$v)
                                  },
                                  expression: "najomca.psc"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "3" } },
                            [
                              _c("v-text-field", {
                                staticClass: "dynamic-input-control sumar-info",
                                attrs: {
                                  label: "Štátne občianstvo",
                                  disabled: "",
                                  "hide-details": "",
                                  outlined: ""
                                },
                                model: {
                                  value: _vm.najomca.statne_obcianstvo,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.najomca,
                                      "statne_obcianstvo",
                                      $$v
                                    )
                                  },
                                  expression: "najomca.statne_obcianstvo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-row",
                    { staticClass: "mt-10px", attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "3" } },
                        [
                          _c("v-text-field", {
                            staticClass: "dynamic-input-control sumar-info",
                            attrs: {
                              label: "Email",
                              disabled: "",
                              "hide-details": "",
                              outlined: ""
                            },
                            model: {
                              value: _vm.najomca.email,
                              callback: function($$v) {
                                _vm.$set(_vm.najomca, "email", $$v)
                              },
                              expression: "najomca.email"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "3" } },
                        [
                          _c("v-text-field", {
                            staticClass: "dynamic-input-control sumar-info",
                            attrs: {
                              label: "Tel. číslo",
                              disabled: "",
                              "hide-details": "",
                              outlined: ""
                            },
                            model: {
                              value: _vm.najomca.mobil,
                              callback: function($$v) {
                                _vm.$set(_vm.najomca, "mobil", $$v)
                              },
                              expression: "najomca.mobil"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "mt-10px", attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "3" } },
                        [
                          _c("v-text-field", {
                            staticClass: "dynamic-input-control sumar-info",
                            attrs: {
                              value: _vm.najomca.konecny_uzivatel_vyhod
                                ? "Áno"
                                : "Nie",
                              label: "Konečný užívateľ výhod",
                              disabled: "",
                              "hide-details": "",
                              outlined: ""
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "3" } },
                        [
                          _c("v-text-field", {
                            staticClass: "dynamic-input-control sumar-info",
                            attrs: {
                              value: _vm.najomca.statutarny_zastupca
                                ? "Áno"
                                : "Nie",
                              label: "Štatutárny zástupca",
                              disabled: "",
                              "hide-details": "",
                              outlined: ""
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "3" } },
                        [
                          _c("v-text-field", {
                            staticClass: "dynamic-input-control sumar-info",
                            attrs: {
                              label: "Funkcia",
                              disabled: "",
                              "hide-details": "",
                              outlined: ""
                            },
                            model: {
                              value: _vm.najomca.vztah_k_najomcovi,
                              callback: function($$v) {
                                _vm.$set(_vm.najomca, "vztah_k_najomcovi", $$v)
                              },
                              expression: "najomca.vztah_k_najomcovi"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "content-class": _vm.fullSize ? "w100" : "pdf-width",
            persistent: ""
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "pdf-viewer dialog-card" },
            [
              _c(
                "v-card-title",
                { staticStyle: { display: "flex" } },
                [
                  _c("span", [_vm._v("Udelenie súhlasu")]),
                  _c(
                    "v-icon",
                    {
                      staticStyle: { "margin-left": "auto" },
                      on: {
                        click: function($event) {
                          return _vm.closeSuhlasDialog()
                        }
                      }
                    },
                    [_vm._v("mdi-close")]
                  )
                ],
                1
              ),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-row",
                    { staticClass: "pdf-component" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "pdf-column",
                          class: { "pdf-column--fullscreen": _vm.fullSize }
                        },
                        [
                          _c(
                            "pdf",
                            {
                              ref: "pdf",
                              staticClass: "pdf",
                              attrs: { src: _vm.pdfdata, page: _vm.page }
                            },
                            [
                              _c("template", { slot: "loading" }, [
                                _vm._v(" loading content here... ")
                              ])
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "pdf-navigation" },
                    [
                      _c(
                        "v-col",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { cols: "1" }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              on: {
                                click: function($event) {
                                  _vm.page > 1 ? _vm.page-- : 1
                                }
                              }
                            },
                            [_vm._v("mdi-chevron-left")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "pages",
                          staticStyle: { "text-align": "center" }
                        },
                        [
                          _vm._v(
                            " Strana " +
                              _vm._s(_vm.page) +
                              " z " +
                              _vm._s(_vm.numPages) +
                              " "
                          )
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { cols: "1" }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              on: {
                                click: function($event) {
                                  _vm.page < _vm.numPages ? _vm.page++ : 1
                                }
                              }
                            },
                            [_vm._v("mdi-chevron-right")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "px-5 py-4", staticStyle: { display: "block" } },
                [
                  _c(
                    "v-row",
                    { staticClass: "pdf-actions" },
                    [
                      _c(
                        "v-col",
                        {
                          staticStyle: { display: "flex" },
                          attrs: { cols: "12" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "pa-2 ma-2",
                              on: {
                                click: function($event) {
                                  _vm.fullSize = !_vm.fullSize
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                { staticStyle: { cursor: "pointer" } },
                                [_vm._v("$full_screen")]
                              )
                            ],
                            1
                          ),
                          _c("div", { staticClass: "pa-2 ma-2" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.link,
                                  download: _vm.fileName
                                }
                              },
                              [
                                _c(
                                  "v-icon",
                                  { staticStyle: { cursor: "pointer" } },
                                  [_vm._v("mdi-download-outline")]
                                )
                              ],
                              1
                            )
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "pa-2 ma-2",
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function($event) {
                                  return _vm.zoom()
                                }
                              }
                            },
                            [
                              _c("v-icon", [_vm._v("mdi-magnify")]),
                              _c("span", [
                                _vm._v(" " + _vm._s(_vm.scale) + " x ")
                              ])
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "my-1 card-actions" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "py-0",
                          staticStyle: { "margin-left": "auto" },
                          attrs: { cols: "12", md: "auto" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn-secondary",
                              attrs: {
                                density: "default",
                                variant: "elevated"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.setSuhlas(false)
                                }
                              }
                            },
                            [_vm._v(" Nesúhlasím ")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "py-0",
                          attrs: { cols: "12", md: "auto" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn-primary",
                              attrs: {
                                variant: "elevated",
                                density: "default"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.setSuhlas(true)
                                }
                              }
                            },
                            [_vm._v(" Oboznámil/a som sa a súhlasím ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("dokumenty-upload-dialog", {
        attrs: {
          "new-id": _vm.pripad ? _vm.pripad.newId : null,
          "default-typ-dokumentu-id": _vm.typDokumentuId
        },
        on: { uploaded: _vm.handleSensitiveBusinessUploaded },
        model: {
          value: _vm.dokumentUploadDialog,
          callback: function($$v) {
            _vm.dokumentUploadDialog = $$v
          },
          expression: "dokumentUploadDialog"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }